import { render } from "./TheAuthentication.vue?vue&type=template&id=35d42fee&ts=true"
import script from "./TheAuthentication.vue?vue&type=script&lang=ts"
export * from "./TheAuthentication.vue?vue&type=script&lang=ts"

import "./TheAuthentication.vue?vue&type=style&index=0&id=35d42fee&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__